import {IApplicationLink} from "./IApplicationLink";
import {IOptionsViewUserSettings} from "../views/OptionsView/OptionsViewSettings";
import {IBaseOptionsViewUserSettings} from "../views/BaseOptionsView/BaseOptionsViewSettings";
import {IPslEmailSubscription} from "./IPslEmailSubscription";

/*
 * Increase the version for every incompatible change to
 * the structure of IUserSettings.
 */
export const USER_SETTINGS_VERSION = 6;

export interface IUserSettings {
    // the version of the user setting instance. may be different
    // from USER_SETTINGS_VERSION when loaded from the back end.
    version: number;

    // automatically filled list of last pages the user visited
    // to help him/her continue his/her work
    recentWork: IApplicationLink[];
    // currently selected languageY
    language: string;
    /** UserSettings for options view */
    optionsView: IOptionsViewUserSettings;

    // TODO the baseoption field can be removed entirely. There's no data in there and it's not actually used.
    /** UserSettings for base options view */
    baseOptionsView: IBaseOptionsViewUserSettings;
    /** UserSettings for email subscription */
    pslEmailSubscriptions?: IPslEmailSubscription[];

    /** Switch between header table mods */
    switchHeaderMode: boolean;
}



// WEBPACK FOOTER //
// ./src/data/IUserSettings.tsx